import { createContext, useContext, useState, useEffect } from "react";
import config from "config";
import API from "utils/API";

import { Search } from "semantic-ui-react";

const notifyContextDefaultValues = {
  filters: {},
  defaultFilters: {},
  filterData: {},
  results: {},
  inputs: {},
  storeFilters: () => {},
  storeFilterData: () => {},
  storeInputs: () => {},
  storeResults: () => {},
  dispatch: () => {}, // Dispatch function added
};

const NotifyContext = createContext(notifyContextDefaultValues);

export function NotifyProvider({ children }) {
  let userData = window.$user_profile;
  const defaultFilters = {
    country: userData.is_exo_group === "yes" ? [] : [userData.employed_by],
    limit: 10,
    page: 1,
    keyChange: 0,
    key_form: 0,
    notifytype: [],
    department: [],
    search: "",
    removeItems: {},
    isOpenModalRemoveItem: false,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [filterData, setFilterData] = useState({
    status: "",
    data: "",
    err: 0,
    err_msg: "",
    keyChange: 0,
  });
  const [inputs, setInputs] = useState({
    selectedExportSheet: "all",
    selectedFields: [],
  });
  const [results, setResults] = useState({
    status: "",
    data: "",
    err: 0,
    err_msg: "",
  });

  useEffect(() => {
    if (filterData.keyChange === 0) {
      const mainFunc = async () =>
        await API.post("notify/filter", {
          params: ({
            country_name: [userData.employed_by],
            country_code: [userData.employed_by_code],
            is_access_all_country: userData.user_sess.userCanAccessAllCountries,
            is_exo_group: userData.is_exo_group,
            userID: userData.idu,
            user_country_access_code: userData.user_countries_access.codes,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("notify filter=", decrypt);
          if (decrypt?.status === "success") {
            setFilters({ ...filters, keyChange: Math.random() });
            setFilterData({ ...decrypt, keyChange: Math.random() });
          } else {
            setFilterData({
              err: 1,
              err_msg: decrypt?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setFilterData({ err: 1, err_msg: `Failes : ${err}` });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (filters?.keyChange !== 0 && results?.status !== "inprocess") {
      // console.log(filters);
      setResults({ status: "inprocess" });
      const mainFunc = async () =>
        await API.post("notify/data", {
          params: ({
            userID: userData.idu,
            filters: filters,
            country_name: userData.employed_by,
            is_exo_group: userData.is_exo_group,
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("notify data=", decrypt);
          if (decrypt?.status === "success") {
            setResults(decrypt);
          } else {
            setResults({
              err: 1,
              err_msg: decrypt?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          console.log(`Failes : ${err}`);
          setResults({ status: "", err: 1, err_msg: err });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.keyChange]);

  const storeFilters = (data) => {
    setFilters(data);
  };

  const storeFilterData = (data) => {
    setFilterData(data);
  };

  const storeInputs = (data) => {
    setInputs(data);
  };

  const storeResults = (data) => {
    setResults(data);
  };

  const dispatch = (action) => {
    switch (action.type) {
      case "STORE_FILTERS":
        storeFilters(action.payload);
        break;
      case "STORE_FILTER_DATA":
        storeFilterData(action.payload);
        break;
      case "STORE_INPUTS":
        storeInputs(action.payload);
        break;
      case "STORE_RESULTS":
        storeResults(action.payload);
        break;
      default:
        break;
    }
  };

  const value = {
    filters: filters,
    defaultFilters: defaultFilters,
    filterData: filterData,
    inputs: inputs,
    results: results,
    storeFilters: storeFilters,
    storeFilterData: storeFilterData,
    storeInputs: storeInputs,
    storeResults: storeResults,
    dispatch: dispatch,
  };

  return (
    <NotifyContext.Provider value={value}>{children}</NotifyContext.Provider>
  );
}

export const useNotify = () => useContext(NotifyContext);

